// src/constants/predefinedCategorias.js

export const predefinedCategorias = [
  { id: '1', code: 'S10', nombre: 'Sub 10', edadMin: 8, edadMax: 9 },
  { id: '2', code: 'S12', nombre: 'Sub 12', edadMin: 10, edadMax: 11 },
  { id: '3', code: 'S14', nombre: 'Sub 14', edadMin: 12, edadMax: 13 },
  { id: '4', code: 'S16', nombre: 'Sub 16', edadMin: 14, edadMax: 15 },
  { id: '5', code: 'S18', nombre: 'Sub 18', edadMin: 16, edadMax: 17 },
  { id: '6', code: 'S20', nombre: 'Sub 20', edadMin: 18, edadMax: 19 },
  { id: '7', code: 'S23', nombre: 'Sub 23', edadMin: 20, edadMax: 22 },
  { id: '8', code: 'LIB', nombre: 'Abierta o Libre', edadMin: 23, edadMax: 29 },
  { id: '9', code: 'SMA', nombre: '30-34', edadMin: 30, edadMax: 34 },
  { id: '10', code: '1MAST', nombre: '35-39', edadMin: 35, edadMax: 39 },
  { id: '11', code: '2MAST', nombre: '40-49', edadMin: 40, edadMax: 49 },
  { id: '12', code: '3MAST', nombre: '50-59', edadMin: 50, edadMax: 59 },
  { id: '13', code: '4MAST', nombre: '60-69', edadMin: 60, edadMax: 69 },
  { id: '14', code: '5MAST', nombre: '70-79', edadMin: 70, edadMax: 79 },
  { id: '15', code: '6MAST', nombre: '80-89', edadMin: 80, edadMax: 89 },
  { id: '16', code: '7MAST', nombre: '90-99', edadMin: 90, edadMax: 109 },
];

export default predefinedCategorias;